<div *transloco="let t">
	<ng-container>
		<div class="flex flex-col">
			<h3 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('billing.reAllocateUser') }}</h3>
			<mat-dialog-content>
				<div class="grid grid-cols-2 gap-4">
					<div class="flex flex-col">
						<div>{{ t('billing.instanceToMigrate') }}:</div>
						<div>
							<mat-form-field appearance="outline" class="w-full">
								<mat-select [disabled]="true" [value]="instanceToMigrate().exportId">
									<mat-option [value]="instanceToMigrate().exportId">
										{{ instanceToMigrate()?.number }}/{{ instanceToMigrate()?.subNumber }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div>
							<mat-form-field appearance="outline" class="w-full">
								<mat-label>{{ t('billing.userToMigrate') }}</mat-label>
								<mat-select [formControl]="userToMigrate">
									@for (user of instanceToMigrate().tenantUnitUserReferences; track user.exportId) {
										<mat-option [value]="user">
											{{ user?.name }}, {{ dateUtil.setDateFormatByActiveLang(user?.validFrom, '') }} -
											{{ dateUtil.setDateFormatByActiveLang(user?.validTo, t('common.today')) }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</div>
					</div>
					<div class="flex flex-col">
						<div>{{ t('billing.mergeWithInstance') }}:</div>
						<div>
							<mat-form-field appearance="outline" class="w-full">
								<mat-label>{{ t('billing.targetInstance') }}</mat-label>
								<mat-select [formControl]="targetInstance">
									@for (instance of instancesInSync; track instance.exportId) {
										<mat-option [value]="instance">{{ instance?.number }}/{{ instance?.subNumber }}</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</div>
						<div>
							<mat-form-field appearance="outline" class="w-full">
								<mat-label>{{ t('billing.targetUser') }}</mat-label>
								<mat-select [formControl]="targetUser">
									@for (user of usersOfTargetInstance(); track user.exportId) {
										<mat-option [value]="user">
											{{ user?.name }}, {{ dateUtil.setDateFormatByActiveLang(user?.validFrom, '') }} -
											{{ dateUtil.setDateFormatByActiveLang(user?.validTo, t('common.today')) }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</div>
						<!--                        @if (targetInstance?.value) {-->
						<!--                            <div>-->
						<!--                                {{ t('common.from') }} {{ targetInstance?.value.validFrom }}  {{ t('common.till') }}  {{ targetInstance?.value.validTo }}-->
						<!--                            </div>-->
						<!--                        }-->
					</div>
					<!--                    <div class="flex flex-col items-center justify-start">-->
					<!--                        <div>{{ t('billing.combinedInfo') }}:</div>-->
					<!--                        <div>-->
					<!--                            @if (targetInstance) {-->
					<!--                                <p><strong>{{ t('billing.fromInstance') }}-->
					<!--                                    :</strong> {{ instanceToMigrate()?.number }}</p>-->
					<!--                                <p><strong>{{ t('billing.toInstance') }}:</strong> {{ targetInstance?.value.number }}-->
					<!--                                </p>-->
					<!--                                <p class="text-sm text-gray-600 mt-2">{{ t('billing.migrationInfo') }}</p>-->
					<!--                            }-->
					<!--                        </div>-->
					<!--                        @if (!targetInstance) {-->
					<!--                            <div class="text-gray-500">-->
					<!--                                {{ t('billing.selectTargetFirst') }}-->
					<!--                            </div>-->
					<!--                        }-->
					<!--                    </div>-->
				</div>
			</mat-dialog-content>
			<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
				<button (click)="close(false)" mat-raised-button type="button">
					<mat-icon>cancel</mat-icon>
					@if (!layoutService.isMobile()) {
						{{ t('commonActions.cancel') }}
					}
				</button>
				<button
					[disabled]="!userToMigrate.value?.exportId || !targetUser.value?.exportId"
					(click)="close(true)"
					color="primary"
					mat-raised-button
					type="submit">
					<mat-icon>check</mat-icon>
					@if (!layoutService.isMobile()) {
						{{ t('common.apply') }}
					}
				</button>
			</mat-dialog-actions>
		</div>
	</ng-container>
</div>
